<div class="ap-accordion">
    <ng-content></ng-content>
</div>
